import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase);

const power5 = () => {
    CustomEase.create('power5.out', 'M0,0,C0.05,0.598,0,1,1,1');
    CustomEase.create('power5.in', 'M0,0 C0.604,0.044 1,0 1,1 ');
    CustomEase.create('power5.inOut', 'M0,0 C0,0.3 0.25,0.499 0.499,0.499 0.748,0.499 1,0.698 1,1 ');    
}

export { power5 };